import type * as models from '../models'

/**
 * {@link https://ngrx.io/docs State} of a given entity collection
 */
export interface State<
  TTypeParams extends models.TypeParams = models.TypeParams,
> {
  /**
   * An object containing contextual information necessary for the entity
   * collection's operations. The specific structure and content of this object
   * may vary based on the requirements of the entity collection (it can also be
   * undefined).
   */
  context: TTypeParams['context'] | undefined
}
export namespace State {
  export const INITIAL: State = {
    context: undefined,
  }
}
